import { render } from "./NotesView.vue?vue&type=template&id=40e63d18&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"

import "./NotesView.vue?vue&type=style&index=0&id=40e63d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e63d18"]])

export default __exports__